export enum UserPermissions {
  // Set to the routes that don't require any permission to be accessed
  NONE = 'None',

  // Modules Access
  CROP_MODULE_ACCESS = 'CropModuleAccess',
  PLANTING_MODULE_ACCESS = 'PlantingModuleAccess',
  MASTERDATA_MODULE_ACCESS = 'MasterdataModuleAccess',

  // User
  USER_MODULE_ACCESS = 'UserModuleAccess',

  // Farm
  FARMS_VIEW = 'FarmsView',
  FARMS_EDIT = 'FarmsEdit',
  FARM_MANAGER = 'FarmManager',

  // Field
  FIELDS_EDIT = 'FieldsEdit',
  FIELDS_VIEW = 'FieldsView',

  // Crop
  CROPS_EDIT = 'CropsEdit',
  CROPS_VIEW = 'CropsView',
  CROPS_DELETE = 'CropsDelete',
  PLANTING_EDIT = 'PlantingEdit',

  // Scouting - reco - inter
  SCOUTINGS_EDIT = 'ScoutingsEdit',
  RECOMMENDATIONS_EDIT = 'RecommendationsEdit',
  INTERVENTIONS_EDIT = 'InterventionsEdit',
  SCOUTINGS_HISTORIC = 'ScoutingsHistoric',

  // Dashboard
  DASHBOARD_VIEW = 'DashboardView',
  WORKLIST_VIEW = 'WorklistView',
  WORKLIST_EDIT = 'WorklistEdit',

  // Sample
  SAMPLE_EDIT = 'SampleEdit',
  SAMPLE_VALIDATE = 'SampleValidate',

  // CSR
  CSR_EDIT = 'CSREdit',
  CSR_VIEW = 'CSRView',
  // Specific permission for allowing a farm that received a JWT token to edit the CSR of the farm
  FARM_CSR_EDIT = 'FarmCSREdit',

  // TPA
  THIRD_PARTY_APPLICATOR_VIEW = 'ThirdPartyApplicatorView',
  THIRD_PARTY_APPLICATOR_TASK_EDIT = 'ThirdPartyApplicatorTaskEdit',

  // Supplier
  SUPPLIER_VIEW = 'SupplierView',
  SUPPLIER_EDIT = 'SupplierEdit',

  MASTERDATA_MANAGER = 'MasterdataManager',

  MASTERDATA_SPECIFICATION = 'MasterdataSpecification',

  MASTERDATA_CSR_EDITION = 'MasterdataCSREdition',

  CONTRACT_MANAGEMENT = 'ContractManagement',

  // Phyto report related permissions
  PHYTO_REPORT_EDIT = 'PhytoReportEdit',
  PHYTO_REPORT_VIEW = 'PhytoReportView',

  RECOMMENDATION_ENTRY_SUPPORT = 'RecommendationEntrySupport',

  PRE_SEASON_INSPECTION = 'PreSeasonInspection',

  // Grants access to the API documentation UI (/doc)
  API_DOCUMENTATION_VIEW = 'ApiDocumentationView',
}
